/* eslint-disable quote-props */
import React from 'react';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  inputLabel: {
    fontSize: '13px',
    marginBottom: 8,
    color: '#505050',
    fontWeight: 500,
  },
  textArea: {
    resize: 'none',
    marginTop: 46,
    border: '1px solid #dadada',
    boxShadow: 'none !important',
    outline: 'none !important',
    borderRadius: 2,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  },
  labelComplement: {
    color: 'red',
    fontSize: '11px',
  },
}));

function InputTextArea({
  labelComplement,
  fullWidth,
  label,
  minRows,
  onChange,
  value,
}) {
  const classes = useStyles();

  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel className={classes.inputLabel}>
        {label}
        <span className={classes.labelComplement}>{labelComplement}</span>
      </InputLabel>
      <TextareaAutosize
        className={classes.textArea}
        onChange={onChange}
        value={value}
        rowsMin={minRows}
      />
    </FormControl>
  );
}

export default InputTextArea;
